import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8fe09dc2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8fe09dc2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe09dc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fe09dc2')) {
      api.createRecord('8fe09dc2', component.options)
    } else {
      api.reload('8fe09dc2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8fe09dc2&scoped=true", function () {
      api.rerender('8fe09dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/right/contentsstyle/index.vue"
export default component.exports